import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ActivityLogTable from '../components/common/ActivityLogTable';
import { fetchActivityLogs } from '../redux/actions/activityLog/activityLogActions';
import { Box, Container } from '@mui/material';
import { fetchColors } from '../api/color/colorApi';
import { fetchPurities } from '../api/purity/purityApi';
import { fetchStocks } from '../api/stock/stockApi';
import { fetchDepartments } from '../api/department/departmentApi';
import { fetchEmployees } from '../api/employee/employeeApi';

const getTodayDateString = () => {
  const today = new Date();
  return today.toISOString().slice(0, 10);
};

const ActivityLogPage = () => {
  const dispatch = useDispatch();
  const { logs, loading, error } = useSelector(state => state.activityLog);
  const { user } = useSelector(state => state.login);
  const [filters, setFilters] = useState({
    from: getTodayDateString(),
    to: getTodayDateString(),
    action: '',
    entity: '',
    user_id: '',
  });
  const [colorMap, setColorMap] = useState({});
  const [purityMap, setPurityMap] = useState({});
  const [stockTypeMap, setStockTypeMap] = useState({});
  const [departmentMap, setDepartmentMap] = useState({});
  const [employeeMap, setEmployeeMap] = useState({});

  // Fetch master data on mount
  useEffect(() => {
    fetchColors().then(res => {
      const map = {};
      (res.data || []).forEach(c => { map[c.id] = c.name; });
      setColorMap(map);
    });
    fetchPurities().then(res => {
      const map = {};
      (res.data || []).forEach(p => { map[p.id] = p.name; });
      setPurityMap(map);
    });
    fetchStocks().then(res => {
      const map = {};
      (res.data || []).forEach(s => { map[s.id] = s.name; });
      setStockTypeMap(map);
    });
    fetchDepartments().then(res => {
      const map = {};
      (res.data || []).forEach(d => { map[d.id] = d.name; });
      setDepartmentMap(map);
    });
    fetchEmployees().then(res => {
      const map = {};
      (res.data || []).forEach(e => { map[e.id] = e.name; });
      setEmployeeMap(map);
    });
  }, []);

  // Fetch logs on mount (today by default)
  useEffect(() => {
    dispatch(fetchActivityLogs(filters));
    // eslint-disable-next-line
  }, []);

  const handleFilterChange = (key, value) => {
    setFilters(prev => ({ ...prev, [key]: value }));
  };

  const handleSearch = () => {
    dispatch(fetchActivityLogs(filters));
  };

  // Restrict to admin only (after all hooks)
  if (!user || user.role !== 'Admin') {
    return (
      <Container maxWidth="md" sx={{ py: 8 }}>
        <Box sx={{ textAlign: 'center', mt: 8 }}>
          <h2>Not Authorized</h2>
          <p>You do not have permission to view this page.</p>
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Box>
        <ActivityLogTable
          logs={logs}
          loading={loading}
          error={error}
          filters={filters}
          onFilterChange={handleFilterChange}
          onSearch={handleSearch}
          colorMap={colorMap}
          purityMap={purityMap}
          stockTypeMap={stockTypeMap}
          departmentMap={departmentMap}
          employeeMap={employeeMap}
        />
      </Box>
    </Container>
  );
};

export default ActivityLogPage; 